import { z } from "zod";
import { TraceIdSchema } from "../primitives/ids.js";
/** orchestration-error.v1.0 — API/worker structured failures */
export const OrchestrationErrorCodeSchema = z.enum([
    "TENANT_MISMATCH",
    "INVALID_TRANSITION",
    "INVALID_SNAPSHOT",
    "QA_FAILED",
    "HASH_MISMATCH",
    "RETRY_EXHAUSTED",
    "NOT_FOUND",
    "CONFLICT",
    "VALIDATION_ERROR",
]);
export const OrchestrationErrorV1Schema = z
    .object({
    schemaVersion: z.literal("orchestration-error.v1.0"),
    code: OrchestrationErrorCodeSchema,
    message: z.string().min(1).max(4000),
    traceId: TraceIdSchema,
})
    .strict();
//# sourceMappingURL=orchestration-error.js.map